import React from 'react';
import { degrees, postgraduate } from '../data/education';
import { Reveal } from '../components/Reveal';
import { SectionHeading } from '../components/SectionHeading';
export function Education() {
  return <section aria-labelledby="education-title" className="bg-paper-deep py-20 md:py-28" data-id="element-196" data-mp="19vsgwimpbk55">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-197" data-mp="14yiuzcyitqm2">
        <SectionHeading id="education-title" label="08 · Education & qualifications" title="Engineering foundation, business education." data-id="element-198" data-mp="14vwnfdbmrb3u" />

        <div className="mt-16 grid gap-14 lg:grid-cols-12" data-id="element-199" data-mp="vwt3660q8pnr">
          <Reveal className="lg:col-span-7" data-id="element-200" data-mp="vzf9617yyx3v">
            <h3 className="text-sm font-semibold text-ink" data-id="element-201" data-mp="qz10cgyjnj4s">Degrees</h3>
            <ul className="mt-4 border-t border-ink" data-id="element-202" data-mp="lz4usda77jn4">
              {degrees.map(d => <li key={d.title} className="flex items-start gap-6 border-b border-line py-8" data-id="element-203" data-mp="2lbz5yn9atrls">
                  {d.logo && <img src={d.logo} alt={`${d.institution} logo`} className="h-16 w-16 shrink-0 rounded-sm object-cover" data-id="element-204" data-mp="2gd5vz4t80iqd" />}
                  <div className="flex-1" data-id="element-205" data-mp="1kbcsvwshr8it">
                    <p className="font-serif text-2xl text-ink md:text-3xl" data-id="element-206" data-mp="1keij5fcuwgg4">{d.title}</p>
                    <p className="mt-1 text-base text-slate-text" data-id="element-207" data-mp="1ofc728qatv90">{d.institution}</p>
                  </div>
                  <p className="hidden shrink-0 font-serif text-xl tabular-nums text-bronze sm:block" data-id="element-208" data-mp="1agcjl4eivmef">{d.years}</p>
                </li>)}
            </ul>
          </Reveal>

          <Reveal delay={0.05} className="lg:col-span-5" data-id="element-209" data-mp="233p47914hk53">
            <h3 className="text-sm font-semibold text-ink" data-id="element-210" data-mp="2829t4caxche8">Postgraduate studies</h3>
            <ul className="mt-4 border-t border-line" data-id="element-211" data-mp="1tddluhgoz8eo">
              {postgraduate.map(d => <li key={d.title} className="flex items-center gap-4 border-b border-line py-5" data-id="element-212" data-mp="1ybxd8xe21cef">
                  {d.logo && <img src={d.logo} alt={`${d.institution} logo`} className="h-11 w-11 shrink-0 rounded-sm object-cover" data-id="element-213" data-mp="2m19i5l2cmyax" />}
                  <div className="flex-1" data-id="element-214" data-mp="2qt9pvzonuvi2">
                    <p className="text-base font-medium text-ink" data-id="element-215" data-mp="2qub3obx29w3h">{d.title}</p>
                    <p className="mt-0.5 text-sm text-slate-text" data-id="element-216" data-mp="30noz2kdvy6ln">{d.institution}</p>
                  </div>
                  <p className="shrink-0 text-sm tabular-nums text-slate-text" data-id="element-217" data-mp="2vnaoovotakkg">{d.years}</p>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}